import axios from 'axios'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { ModalLogin } from '../components/Modals/ModalLogin'
import { useToast } from '../components/ui/Toast/Toast'
import { constants } from '../Constants'
import { useNotificationsContext } from '../context/NotificationsContext'
import '../styles/shared.scss'

export default function LoginPage() {
  const [isOpen, setIsOpen] = useState(false)
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)
  const [loadingForgotPassword, setLoadingForgotPassword] = useState(false)
  const toast = useToast()
  const { updateNotifications } = useNotificationsContext()

  const handleLogin = async (email, password) => {
    setLoading(true)
    try {
      const response = await axios.post(`${constants.urlLocal}login`, {
        email,
        password,
      })
      const { data } = response
      if (data.ok) {
        localStorage.setItem('token', data.token)
        localStorage.setItem('user', JSON.stringify(data.user))
        updateNotifications(data.user.id)
        navigate('/', { state: { user: data.user } })
        toast({ title: 'Sesión iniciada correctamente', status: 'success' })
      } else {
        toast({
          title: 'Inicio de sesión incorrecto',
          description: 'Revisa tu correo y contraseña',
          status: 'error',
        })
      }
    } catch (error) {
      toast({
        title: 'Inicio de sesión incorrecto',
        description: error.response?.data?.message,
        status: 'error',
      })
    }
    setLoading(false)
  }

  const forgotPassword = async (email, phone, onSuccess) => {
    setLoadingForgotPassword(true)
    try {
      const response = await axios.post(`${constants.urlLocal}forgotPassword`, {
        email,
        phone,
      })
      if (response.data.ok) {
        toast({
          title: 'Correo enviado correctamente',
          description: 'Revisa tu correo para cambiar la contraseña',
          status: 'success',
        })
        onSuccess?.()
      } else {
        toast({
          title: 'Error al enviar el correo',
          description: 'Revisa que el correo sea correcto',
          status: 'error',
        })
      }
    } catch (error) {
      toast({
        title: 'Error al enviar el correo',
        description: error.response?.data?.message,
        status: 'error',
      })
    }
    setLoadingForgotPassword(false)
  }

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem('user'))
    if (user && user.id) {
      navigate('/', { state: { user } })
    } else {
      localStorage.removeItem('user')
    }
  }, [navigate])

  return (
    <div
      className="flex-col-center"
      style={{ minHeight: '80vh', padding: '2rem' }}
    >
      <h2 style={{ fontSize: '1.5rem', fontWeight: 700, textAlign: 'center' }}>
        Bienvenid@ a Funcional Brothers
      </h2>
      <p style={{ color: '#666', marginBottom: '1.5rem', textAlign: 'center' }}>
        Inicia sesión para inscribirte a las clases
      </p>
      <button
        onClick={() => setIsOpen(true)}
        style={{
          padding: '0.75rem 2rem',
          background: '#2440ab',
          color: 'white',
          border: 'none',
          borderRadius: '0.5rem',
          fontSize: '1rem',
          fontWeight: 600,
          cursor: 'pointer',
          transition: 'background 0.2s',
        }}
        onMouseOver={e => (e.target.style.background = '#1a3090')}
        onMouseOut={e => (e.target.style.background = '#2440ab')}
      >
        Iniciar sesión
      </button>
      <p
        style={{
          color: '#666',
          marginTop: '1.5rem',
          textAlign: 'center',
          fontWeight: 600,
          maxWidth: 400,
        }}
      >
        El registro se realiza en The Box.
        <br />
        Los entrenadores allí te darán de alta en la aplicación.
      </p>
      <ModalLogin
        open={isOpen}
        close={() => setIsOpen(false)}
        login={handleLogin}
        forgotPassword={forgotPassword}
        loading={loading}
        loadingForgotPassword={loadingForgotPassword}
      />
      <footer
        style={{
          position: 'fixed',
          bottom: 0,
          left: 0,
          right: 0,
          height: '70px',
          background: '#2440ab',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          gap: '1rem',
        }}
      >
        <a
          href="https://www.instagram.com/funcionalbrothers_/"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            width: 40,
            height: 40,
            borderRadius: '50%',
            background: 'rgba(255,255,255,0.15)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: 'white',
            fontSize: '1.25rem',
            textDecoration: 'none',
          }}
        >
          📷
        </a>
        <a
          href="https://wa.me/34626864059"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            width: 40,
            height: 40,
            borderRadius: '50%',
            background: 'rgba(255,255,255,0.15)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: 'white',
            fontSize: '1.25rem',
            textDecoration: 'none',
          }}
        >
          💬
        </a>
      </footer>
    </div>
  )
}
